
// region JS Imports

// region External Modules
import $ from "jquery"
import u from "umbrellajs"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports
import { Factory } from "./factory"

const CELL_CLASS_NAME = "cell--buildings--overseas-marketing--city-update-subscription--button-form"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    const $el = $(el)

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    Factory.create({
      main: $el,
    })
  })
}

export default {
  init,
}
